export { default } from './CorePublisherLayout';
